<template>
  <!-- menu with submenu -->
  <li v-if="menu.children" :class="{ 'active': subIsActive(menu.path), 'expand': stat =='expand' }" class="has-sub">
    <a v-if="getVisible(menu.pages, true)" href="#" @click.prevent.stop="expand($event)" @mouseover="mouseOver(menu.children, $event)" @mouseleave="hideFloatSubmenu">
      <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
      <b v-else class="caret"/>
      <i v-if="menu.icon" :class="menu.icon"/>
      <div v-if="menu.img" class="icon-img"><img :src="menu.img" alt="" ></div>
      <span>
        {{ menuTitle(menu.title) }}
        <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
        <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"/>
      </span>
    </a>
    <ul :class="{ 'd-block': stat == 'expand', 'd-none': stat == 'collapse' }" :style="{ marginTop: (pageOptions.pageSidebarMinified) ? - (scrollTop + 40) + 'px' : '' }" class="sub-menu">
      <template v-for="submenu in menu.children">
        <template v-if="getVisible(submenu.pages)">
          <sidebar-nav-list ref="sidebarNavList" :menu="submenu" :key="submenu.path" @calcFloatSubmenu="handleCalcFloatSubmenu" @collapse-other="handleCollapseOther(submenu)"/>
        </template>
      </template>
    </ul>
  </li>
  <!-- menu without submenu -->
  <router-link v-else :to="menu.path" active-class="active" tag="li" @click.native="collapseOther()">
    <a :class="{ 'd-none' : $store.getters.accountStatus == 'SUSPEND' && menu.title == 'ui.new_account' }">
      <span v-if="menu.badge" class="badge pull-right">{{ menu.badge }}</span>
      <i v-if="menu.icon" :class="menu.icon"/>
      <div v-if="menu.img" class="icon-img"><img :src="menu.img" alt="" ></div>
      <span>
        <span v-if="menu.title == 'ui.new_account'">{{ $t("ui.new") + ' ' + $helpers.getUplineName($store.getters.accountType-1) }}</span>
        <span v-else-if="menu.title == 'ui.account_list'">{{ $helpers.getUplineName($store.getters.accountType-1) + ' ' + $t("ui.list") }}</span>
        <span v-else>{{ menuTitle(menu.title) }}</span>
        <i v-if="menu.highlight" class="fa fa-paper-plane text-theme"/>
        <span v-if="menu.label" class="label label-theme">{{ menu.label }}</span>
      </span>
    </a>
  </router-link>
</template>

<script>
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '../../config/PageOptions.vue'

export default {
  name: 'SidebarNavList',
  components: {
    SidebarNavList
  },
  props: ['menu', 'scrollTop'],
  data() {
    return {
      stat: '',
      pageOptions: PageOptions
    }
  },
  methods: {
    mouseOver: function(data, event) {
      if (this.pageOptions.pageSidebarMinified) {
        var offset = event.target.offsetParent.getBoundingClientRect();
        this.$emit('showFloatSubmenu', data, offset);
      }
    },
    hideFloatSubmenu: function() {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit('hideFloatSubmenu');
      }
    },
    expand: function() {
      if (this.stat == '') {
        this.stat = (this.subIsActive(this.menu.path)) ? 'collapse' : 'expand';
      } else {
        this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
      }
      this.$emit('collapse-other', this.menu);

      if (this.pageOptions.pageSidebarMinified) {
        this.$emit('calcFloatSubmenu');
      }
    },
    handleCalcFloatSubmenu: function() {
      if (this.pageOptions.pageSidebarMinified) {
        this.$emit('calcFloatSubmenu');
      }
    },
    collapse: function(menu) {
      if (this.menu != menu) {
        this.stat = 'collapse'
      }
    },
    collapseOther: function() {
      this.pageOptions.pageMobileSidebarToggled = false;
      this.pageOptions.pageMobileRightSidebarToggled = false;
      this.$emit('collapse-other', this.menu)
    },
    handleCollapseOther: function(menu) {
      for (var i = 0; i < this.menu.children.length; i++) {
        if(this.$refs.sidebarNavList[i]) {
          this.$refs.sidebarNavList[i].collapse(menu);
        }
      }
    },
    subIsActive(path) {
      const paths = Array.isArray(path) ? path : [path]
      return paths.some(path => {
        return (this.$route.path != '/overview') ? this.$route.matched[0].path.indexOf(path) === 0 : false
      })
    },
    menuTitle: function(title) {
      switch(title){
        case "forecastHDP":
          return this.$t("ui.forecast") + " " + this.$t("ui.hdp")
        case "forecastOXT":
          return this.$t("ui.forecast") + " " + this.$t("m.BT_1X2")
        case "forecastOU":
          return this.$t("ui.forecast") + " " + this.$t("ui.ou")
        case "forecastOE":
          return this.$t("ui.forecast") + " " + this.$t("ui.oe")
        default:
          return this.$t(title)
      }
    },
    getVisible: function(e) {
      let accountRole = this.$store.getters.authorityRole
      if(accountRole == "SUB_PRI") {
        if (e.length > 0) {
          let result = false;
          let pages = e;
          let roles = this.$store.getters.accessRoles.authority_option;
          roles = roles.split(',')
          for (var i = 0; i < pages.length; i++) {
            for (var j = 0; j < roles.length; j++) {
              if (pages[i] == 'operator_limit' && roles[j] == 'edit_limit') {
                if (this.$store.getters.accountType == 2){
                  result = true;
                  return result;
                }
              }
              else if (pages[i] == 'edit_ip' && roles[j] == 'edit_account') {
                if (this.$store.getters.accountType == 3){
                  result = true;
                  return result;
                }
              }
              else if (pages[i] == 'edit_account' && roles[j] == 'edit_account') {
                if (this.$store.getters.accountType != 2){
                  result = true;
                  return result;
                }
              }
              else if (pages[i] == 'stock' && roles[j] == 'report') {
                if (this.$store.getters.accountType == 2){
                  result = true;
                  return result;
                }
              }
              else if (pages[i] == 'tournament' && roles[j] == 'account') {
                // if (this.$store.getters.accountType == 2){
                if (this.$store.getters.accountType == 2 && this.$store.getters.getTournamentFlag == true){
                  result = true;
                  return result;
                }
              }
              else {
                if (roles[j] == pages[i]) {
                  result = true;
                  return result;
                }
              }
            }
          }
          return result;
        } else {
          return true
        }
      } else {
          if (e.length > 0) {
            let result = true;
            let pages = e;

            for (var i = 0; i < pages.length; i++) {
              if(pages[i] == 'operator_limit' && this.$store.getters.accountType != 2){
                result = false;
                break;
              }
              else if(pages[i] == 'edit_ip' && this.$store.getters.accountType != 3){
                result = false;
                break;
              }
              else if(pages[i] == 'edit_account' && this.$store.getters.accountType == 2){
                result = false;
                break;
              }
              else if(pages[i] == 'stock' && this.$store.getters.accountType != 2){
                result = false;
                break;
              }
              // else if(pages[i] == 'tournament' && this.$store.getters.accountType != 2){
              else if(pages[i] == 'tournament' && (this.$store.getters.accountType != 2 || this.$store.getters.getTournamentFlag != true)){
                result = false;
                break;
              }
              else{
                result = true;
                break;
              }
            }
            return result;
          }
          return true;
        }
    }
  }
}
</script>
